import { Toast } from 'vant'
import { backOriCashierPage } from "@/utils/navigation"

const loading = Toast.loading
const quickSave = window.quickSave
// ios
const flutterApp = window.flutter_inappwebview

// loading
function showLoading() {
  loading({
    message: 'loading',
    forbidClick: true,
    duration: 0
  })
  // if (quickSave && quickSave.showLoading) {
  //   quickSave.showLoading()
  // } else {
  //   loading({
  //     message: 'loading',
  //     forbidClick: true,
  //     duration: 0
  //   })
  // }
}
// loading
function hideLoading() {
  loading().clear()
  // if (quickSave && quickSave.hideJsLoading) {
  //   quickSave.hideJsLoading()
  // } else {
  //   loading().clear()
  // }
}
// 错误消息弹框
function showToast(str) {
  if (quickSave && quickSave.showJsToast) {
    quickSave.showJsToast(str)
  } else {
    Toast({
      message: str
    })
  }
}
// 截屏
function screenCapture() {
  if (quickSave && quickSave.screenCapture) {
    quickSave.screenCapture()
    return true
  } else {
    return false
  }
}

function gotoHomeActivity() {
  if (quickSave && quickSave.gotoHomeActivity) {
    quickSave.gotoHomeActivity()
  } else {
    console.log('客户端 gotoHomeActivity 方法失败')
  }
} 
// 客户端关闭 webview 页面
function finishAndroidWebPage() {
  if (quickSave && quickSave.finishAndroidWebPage) {
    console.log('客户端 quickSave.finishAndroidWebPage 方法成功')
    quickSave.finishAndroidWebPage()
  } else if (quickSave && quickSave.gotoHomeActivity) {
    console.log('客户端 quickSave.gotoHomeActivity 方法成功')
    quickSave.gotoHomeActivity()
  } else if (quickSave && quickSave.otherRequest) {
    console.log(`客户端 quickSave.otherRequest('gotoHomeActivity', '', '')`)
    quickSave.otherRequest('gotoHomeActivity', '', '')
  } else if (window.dopplerLib && window.dopplerLib.finishAndroidWebPage) {
    window.dopplerLib.finishAndroidWebPage()
  } else if (window.ponyKashConnect && window.ponyKashConnect.ponyAnotherNetworkLoading) {
    window.ponyKashConnect.ponyAnotherNetworkLoading('openPonyHomeActivity', '', '')
  } else if (flutterApp) {
    flutterApp.callHandler('gotoHomeActivity')
  } else {
    console.log('客户端方法失败')
  }
}
// 关闭当前 webview 页面
function closeWebPage() {
  if (quickSave && quickSave.otherRequest) {
    quickSave.otherRequest('finishAndroidWebPage', '', '')
  } else if (window.ponyKashConnect && window.ponyKashConnect.ponyAnotherNetworkLoading) {
    window.ponyKashConnect.ponyAnotherNetworkLoading('exitPony', '', '')
  } else if (flutterApp) {
    flutterApp.callHandler('finish')
    flutterApp.callHandler('commonRequest', 'finish', '', '')
  } else {
    console.log('客户端方法失败')
  }
}
// 公共方法返回或者退出当前H5
function closeCurrentH5(name) {
  console.log('closeCurrentH5', name)
  clearInterval(window.timer)
  window.timer = null
  // 1、5、7: APP； 2、4: H5； 3、6: 短链
  // 17:ionic app palmcredit，原生我的页面到绑卡的返回
  const type = localStorage.getItem('scene')
  const appScenes = ['1', '5', '7', '17']
  const appHomeScene = ['1801', '1804']
  const mobileWebScene = ['1802', '1803', '1805', '1806'] // benefit
  if (appScenes.includes(type)) {
    finishAndroidWebPage()
  } else if (appHomeScene.includes(type)) {
    gotoHomeActivity()
  } else if (mobileWebScene.includes(type)) {
    gotoHomeActivity()
  } else if (type === '7') {
    closeWebPage()
  } else if (type === '16') {
    backOriCashierPage()
  } else if (type === '2' || type === '4' || type === '4001' || type === '4002' || type === '4003') {
    if (name === 'payMethod' || name === 'bindCard' || name === 'bankCardTabs') {
      history.go(-1)
    } else {
      history.go(-2)
    }
  } else {
    history.go(-1)
  }
}
// function getUuid() {
//   var s = []
//   var hexDigits = '0123456789abcdef'
//   for (var i = 0; i < 36; i++) {
//     s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
//   }
//   s[14] = '4'
//   s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
//   s[8] = s[13] = s[18] = s[23] = '-'
//   var uuid = s.join('')
//   return uuid
// }
// app埋点
// 进入页面
function startPage(pageName) {
  try {
    if (quickSave && quickSave.startPage) {
      quickSave.startPage(pageName)
    }
  } catch (e) {
    console.log('catch-err--startPage')
  }
}
// 离开页面
function endPage(pageName) {
  try {
    if (quickSave && quickSave.endPage) {
      quickSave.endPage(pageName)
    }
  } catch (e) {
    console.log('catch-err--endPage')
  }
}
// 点击事件
function logClickEvent(pageName, eventName) {
  try {
    if (quickSave && quickSave.logClickEvent) {
      quickSave.logClickEvent(pageName, eventName)
    }
  } catch (e) {
    console.log('catch-err--logClickEvent')
  }
}
// 其他事件
function logViewEvent(pageName, eventName) {
  try {
    if (quickSave && quickSave.logViewEvent) {
      console.log('quickSave.logViewEvent', quickSave.logViewEvent)
      quickSave.logViewEvent(pageName, eventName)
    }
  } catch (e) {
    console.log('catch-err--logViewEvent')
  }
}
// 独立埋点sdk方法
function reportBySDK(eventName) {
  // const type = localStorage.getItem('scene')
  // if (type !== '2' || type === '4') {
  //   return
  // }
  // const dopplerLib = window.dopplerLib
  // if (dopplerLib && dopplerLib.httpsRequest) {
  //   const baseURL = process.env.NODE_ENV === 'production' ? 'https://wolf-api.allcreditcom.com' : 'https://loanstation-bigdata-api.dexintec.cn' 
  //   const params = {
  //     url: `${baseURL}/app/event/v2`,
  //     body: {
  //       data: {
  //         trace_id: localStorage.getItem('trace_id'),
  //         event_name: eventName,
  //         event_time: Date.now(),
  //         event_type: 'card',
  //         event_id: getUuid()
  //       }
  //     },
  //     header: {},
  //     callback: 'reportSDKCallback'
  //   }
  //   dopplerLib.httpsRequest(params.url, JSON.stringify(params.body), JSON.stringify(params.header), params.callback)
  // } else {
  //   console.log('调用httpsRequest失败')
  // }
}
// 监听短信
function startSmsListener(str) {
  try {
    console.log('调用startSmsListener')
    if (quickSave && quickSave.startSmsListener) {
      quickSave.startSmsListener(str)
    } else {
      console.log('startSmsListener失败')
    }
  } catch (e) {
    console.log('catch-err--startSmsListener')
  }
}
// 停止监听
function finishSmsListener() {
  try {
    if (quickSave && quickSave.finishSmsListener) {
      quickSave.finishSmsListener()
    } else {
      console.log('finishSmsListener失败')
    }
  } catch (e) {
    console.log('catch-err--finishSmsListener')
  }
}

/**
 * 跳转到原生页面
 * @param {String} type 指定页面类型
 * waitReviewPage 原生绑卡等待页
 */
function gotoNativePage(type) {
  try {
    if (quickSave && quickSave.gotoNativePage) {
      quickSave.gotoNativePage(type)
    } else {
      console.log('gotoNativePage 失败')
    }
  } catch (e) {
    console.log('catch-err--finishSmsListener')
  }
}

/**
 * 获取uid
 */
function getUid() {
  try {
    if (quickSave && quickSave.getUid) {
      return quickSave.getUid();
    }
  } catch (e) {
    console.log('catch-err--getUid')
  }
  return '';
}

/**
 * 获取设备id
 */
function getDeviceId() {
  try {
    if (quickSave && quickSave.getDeviceId) {
      return quickSave.getDeviceId();
    }
  } catch (e) {
    console.log('catch-err--getDeviceId')
  }
  return '';
}

export {
  showLoading,
  hideLoading,
  showToast,
  screenCapture,
  gotoHomeActivity,
  finishAndroidWebPage,
  closeCurrentH5,
  reportBySDK,
  startSmsListener,
  finishSmsListener,
  startPage,
  endPage,
  logClickEvent,
  logViewEvent,
  gotoNativePage,
  getUid,
  getDeviceId
}
